import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { uerWorkOrderChangeObjectTotalsGql } from 'pages/Project/UerProject/WorkOrderChange/WorkOrderChangeQueries';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

const requestId = 'uerWorkOrderChangeObjectTotals';

export const useUerWorkOrderChangeObjectTotals = (workOrderChangeId: number) => {
    const dispatch = useDispatch();

    const [uerWorkOrderChangeObjectTotalsReset] = useResetStoreData({ requestId });

    const [
        uerWorkOrderChangeObjectTotalsData,
        uerWorkOrderChangeObjectTotalsStatus,
        ,
        uerWorkOrderChangeObjectTotalsRequest,
    ] = useRequest({
        requestId,
        query: uerWorkOrderChangeObjectTotalsGql,
        withEffect: false,
    });

    const uerWorkOrderChangeObjectTotalsMakeRequest = useCallback(
        (workOrderObjectId: number, workOrderChangeObjectId: number) => {
            uerWorkOrderChangeObjectTotalsReset(undefined);
            dispatch(
                uerWorkOrderChangeObjectTotalsRequest({
                    workOrderObjectId,
                    workOrderChangeId,
                    workOrderChangeObjectId,
                }),
            );
        },
        [dispatch, uerWorkOrderChangeObjectTotalsRequest, uerWorkOrderChangeObjectTotalsReset, workOrderChangeId],
    );

    return {
        uerWorkOrderChangeObjectTotalsData,
        uerWorkOrderChangeObjectTotalsStatus,
        uerWorkOrderChangeObjectTotalsMakeRequest,
    };
};
